import { SelectProps } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface FormSelectProps extends SelectProps {
  label?: string;
  description?: React.ReactNode;
  className?: string;
  labelClassName?: string;
  options?: { label: string; value: string }[];
  error?: string;
}

export default function FormSelect({
  label,
  description,
  className,
  labelClassName,
  options,
  error,
  ...otherProps
}: FormSelectProps) {
  return (
    <div
      className={twMerge([
        'flex w-auto flex-col items-start justify-start gap-1',
        className,
      ])}
    >
      {label && (
        <span
          className={twMerge([
            'text-sm font-medium leading-6 text-gray-900',
            labelClassName,
          ])}
        >
          {label}
        </span>
      )}
      {description && (
        <span className="block text-sm text-gray-500">{description}</span>
      )}
      <div className="relative w-full">
        <select
          className={twMerge([
            'block h-9 w-full appearance-none rounded-md border-0 px-2 py-2 pr-10 leading-6 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 disabled:bg-gray-100 sm:text-sm',
            error && 'ring-red-500',
          ])}
          {...otherProps}
        >
          {options?.map((o, index) => (
            <option key={index} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-0 top-0 flex h-full items-center rounded-r-md border-gray-300 px-2 text-gray-400 sm:text-sm">
          <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
        </span>
      </div>
      {error && (
        <p className="text-sm text-red-500" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
